import React from 'react';
import { ValueEntryModal } from '../../../../../components/ValueEntryModal/ValueEntryModal';
import type { ValueEntryResult } from '../../../../../components/ValueEntryModal/ValueEntryModal';

type AmountEntryDialogProps = {
  isOpen: boolean;
  lineFullTotal: number;
  methodLabel: string;
  allowOverage?: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: (total: number) => void;
};

// Split-pay amount on the shared ValueEntryModal: prefilled and capped at the line amount-due.
const AmountEntryDialogComponent: React.FC<AmountEntryDialogProps> = ({
  isOpen,
  lineFullTotal,
  methodLabel,
  allowOverage = false,
  isSubmitting,
  onClose,
  onConfirm,
}) => (
  <ValueEntryModal
    isOpen={isOpen}
    title={methodLabel}
    amountOnly
    prefillAmount={lineFullTotal}
    percentBase={lineFullTotal}
    infoRightLabel="סכום לחיוב"
    infoRightValue={lineFullTotal}
    inputLabels={{ percentage: 'אחוז', amount: 'סכום לתשלום' }}
    maxAmount={allowOverage ? undefined : lineFullTotal}
    capAmountMessage={allowOverage ? undefined : 'הסכום גבוה מהסכום לתשלום'}
    confirmLabel="אישור"
    dataTestId="split-payment-amount"
    isSaving={isSubmitting}
    onClose={onClose}
    onConfirm={(result: ValueEntryResult) => onConfirm(result.amount)}
  />
);

export const AmountEntryDialog = React.memo(AmountEntryDialogComponent);
